import { makeAutoObservable } from 'mobx';
import { FAILURE, REQUEST, SUCCESS, UNSET } from '../../constants/status';
class jobList {
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
  test = 'qwq';
  status = UNSET;
  data = [];
  // {
  //   completeTime: '',
  //   createTime: '',
  //   jobId: 27,
  //   param: {},
  //   result: null,
  //   status: ['正在运行'],
  // }
  request = () => {
    this.status = REQUEST;
  };
  request_success = (dataInject) => {
    this.data = dataInject;
    this.status = SUCCESS;
  };
  request_fail = () => {
    this.status = FAILURE;
  };
}
export default jobList;
